import {
	forwardRef,
	ReactElement,
	Ref
} from "react";
import { RoundButton } from "../RoundButton/RoundButton";
import { FontIconName } from "../Icon/Icon";
import { Portal } from "../Portal/Portal";
import styles from "./FloatingActionButton.module.less";
import { MediaQueryKind, useWorkspaceMediaQuery } from "client/Hooks";

export type FloatingActionButtonProps = {
	icon?: FontIconName;
	onClick: () => void;
	isActive?: boolean;
	visibleOn?: "responsive" | "always";
	trackingId: string;
};

export const FloatingActionButton = forwardRef(
	(props: FloatingActionButtonProps, ref: Ref<HTMLButtonElement>): ReactElement | null => {
		const {
			icon = "plus",
			onClick,
			isActive = false,
			visibleOn = "responsive",
			trackingId
		} = props;

		const isResponsive: boolean = useWorkspaceMediaQuery(MediaQueryKind.Responsive);

		if (visibleOn === "responsive" && !isResponsive) {
			return null;
		}

		return (
			<Portal container="#mobile-plus-menu-host">
				<div className={styles.root}>
					<div className={styles.buttonContainer}>
						<RoundButton
							icon={icon}
							isActive={isActive}
							onClick={onClick}
							trackingId={trackingId}
							ref={ref}
						/>
					</div>
				</div>
			</Portal>
		);
	}
);
FloatingActionButton.displayName = "FloatingActionButton";
